import React, { useState } from "react"
import { useTranslation } from "react-i18next"
import Button from "shared/components/button"
import MarketsDisplayListComponent from "./MarketsDisplayListComponent"
const MarketsButtonComponent = () => {
  const { t } = useTranslation()
  const [viewProfession, setViewProfession] = useState(false)
  const setviewProfessionButton = () => {
    setViewProfession(previousState => !previousState)
  }
  return (
    <div>
      <Button
        name="Common Professions"
        type="button"
        className="market-btn"
        onClick={setviewProfessionButton}
      >
        {!viewProfession && (
          <div className="market-btn-text">
            <span>{t("mk.btn_view_profession")}</span>
            <span>+</span>
          </div>
        )}
        {viewProfession && (
          <div className="market-btn-text">
            <span>{t("mk.btn_hide_profession")}</span>
            <span>-</span>
          </div>
        )}
      </Button>
      {viewProfession && (
        <MarketsDisplayListComponent></MarketsDisplayListComponent>
      )}
    </div>
  )
}
export default MarketsButtonComponent
